module.exports = __webpack_public_path__ + "img/play-f.8c44ec50.png";